import { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  createUserAsync,
  editUserAsync,
  fetchUsersAsync,
  removeUserAsync,
} from "../../features/services/user/UserSlice";
import { User } from "../../features/services/user/User.type";

const useUsers = () => {
  const dispatch = useAppDispatch();
  const users = useAppSelector((state) => state.user.users);
  const error = useAppSelector((state) => state.user.error);
  const loading = useAppSelector((state) => state.user.status);

  const createUser = (user: User) => dispatch(createUserAsync(user));
  const editUser = (user: User) => dispatch(editUserAsync(user));
  const removeUser = (userId: number) => dispatch(removeUserAsync(userId));

  useEffect(() => {
    dispatch(fetchUsersAsync());
  }, [dispatch]);

  const memoizedUsers = useMemo(() => users, [users]);

  return {
    users: memoizedUsers,
    error,
    loading,
    createUser,
    editUser,
    removeUser,
  };
};

export default useUsers;
